<div class="loading">
  <i class="material-icons">refresh</i>
</div>
